import { Component, Inject, OnInit } from '@angular/core';
import moment from 'moment';
import { IResponse } from 'src/app/shared/models/app';
import { CacheConstant } from 'src/app/core/cache/cache.constant';
import { CacheResolverService } from 'src/app/core/cache/cache-resolver.service';
import { HomeService } from 'src/app/modules/home/home.service';
import { MatDialogRef } from '@angular/material/dialog';
import { CommonService } from '../../common.service';
import { ToastService } from 'src/app/shared/utils/toast.service';
import { DateFormat } from 'src/app/core/constants/app.constant';

@Component({
    selector: 'nphs-user-rejected-request',
    templateUrl: './rejected-request.component.html',
    styleUrls: ['./rejected-request.component.scss'],
    standalone: false
})
export class RejectedRequestComponent implements OnInit {

  notificationData = [];

  constructor(private homeService: HomeService,
    private commonService: CommonService,
    private cache: CacheResolverService,
    public dialog: MatDialogRef<RejectedRequestComponent>,
    private toastService: ToastService,) { }

  ngOnInit(): void {
    this.Init()
  }

  private Init() {
    this.getNotificationData();
  }

  getShipto() {
    const date = this.homeService._dashboardDate;
    const data = {
      startDate:  moment(date).startOf("day").utc().format(),
      customerShipToNum: this.cache.get(CacheConstant.LocalStorage.ShipTo),
    }
    return data
  }

  private getNotificationData() {
    let data = this.getShipto();
    this.homeService.getNotificationDetails(data).subscribe((response: IResponse) => {

      if(!response.hasError)
      {
        if(response.data != null)
        {
          this.commonService.rejectedRequestChanged$.next(response.data.length);

          let transformedData = this.transformNotification(response.data);
        }
        else{
          this.commonService.rejectedRequestChanged$.next(0);

          this.dialog.close();
        }

      }
      else
      {
        const message = response.error.faultInfos[0];
        this.toastService.error(message.faultMessage, 'ERROR!')
      }

    });
  }

  transformNotification(response) {
    this.notificationData = response;
    let notificationData = [];
    if (response) {
      response.forEach((item, index) => {
        notificationData[index] = (item);
        notificationData[index].calibrationTime = moment(new Date(item.calibrationTime)).format(DateFormat.HHMM);
        notificationData[index].rejectTime = moment(new Date(item.rejectTime)).format(DateFormat.MMDDYYYYHMM)
      })
    }
    return notificationData;
  }

  clear(data, all) {
    var rejectRequestMessageNumbers = []
    if (all) {
      data.forEach((message) => {
        rejectRequestMessageNumbers.push(message.rejectedMsgNumber);
      });
    }
    else {
      var index = -1;
      rejectRequestMessageNumbers.push(data[0].rejectedMsgNumber);
      this.notificationData.forEach((message, ind) => {
        if (message.rejectedMsgNumber == data[0].rejectedMsgNumber) {
          index = ind;
        }
      })
    }
    var retVal = {
      rejectRequestMessageNumbers: rejectRequestMessageNumbers,
      customerShipToNum: this.cache.get(CacheConstant.LocalStorage.ShipTo),
    }
    this.homeService.dismissMessage(retVal).subscribe((response: IResponse) => {
      this.notificationData.splice(index, 1);
      this.getNotificationData();
    })
  }
}
